<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_1"></a>Contents</h2>
<p class="toca"><a href="#/xhtml/foreword"><em>Author’s foreword</em></a></p>
<div class="lb-db">
<p class="toc1"><a href="#/xhtml/chapter01"><strong>GETTING STARTED</strong></a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec1">What is pruning?</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec2">Philosophy of pruning</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec3">Plant groups and treatments</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec4">Tackling neglected gardens</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec5">Equipment you will need</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec6">Preparing plants for planting</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec7">Making the right cut</a></p>
<p class="image"><img alt="Illustration" id="f0001-01" src="images/f0001-01.jpg"/></p>
</div>
<div class="org-dorg">
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong>SHRUBS, TREES AND CLIMBERS</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec8" title="Link target outside of Sample">Philosophy of pruning shrubs</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec9" title="Link target outside of Sample">Philosophy of pruning trees</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec10" title="Link target outside of Sample">Philosophy of pruning climbers</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec11" title="Link target outside of Sample">A–Z of pruning shrubs, trees and climbers</span></p>
<p class="image"><img alt="Illustration" id="f0001-02" src="images/f0001-02.jpg"/></p>
</div>
<div class="gr-dgr">
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><strong>HEDGES AND CONIFERS</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec12" title="Link target outside of Sample">Foliage hedges</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec13" title="Link target outside of Sample">Flowering hedges</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec14" title="Link target outside of Sample">Conifers</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec15" title="Link target outside of Sample">Forming arches and tunnels</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec16" title="Link target outside of Sample">Topiary</span></p>
</div>
<div class="vio-dvio">
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong>ROSES</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec17" title="Link target outside of Sample">Roses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec18" title="Link target outside of Sample">Patio and miniature roses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec19" title="Link target outside of Sample">Rose hedges</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec20" title="Link target outside of Sample">Standard roses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec21" title="Link target outside of Sample">Shrub roses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec22" title="Link target outside of Sample">Climbing roses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec23" title="Link target outside of Sample">Rambling roses</span></p>
</div>
<div class="bu-dbu">
<p class="toc1"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><strong>FRUIT</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec24" title="Link target outside of Sample">Apples</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec25" title="Link target outside of Sample">Pears</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec26" title="Link target outside of Sample">Plums</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec27" title="Link target outside of Sample">Peaches and nectarines</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec28" title="Link target outside of Sample">Raspberries</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec29" title="Link target outside of Sample">Blackberries, hybrid berries and loganberries</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec30" title="Link target outside of Sample">Black currants</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec31" title="Link target outside of Sample">Red and white currants</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec32" title="Link target outside of Sample">Gooseberries</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec33" title="Link target outside of Sample">Figs</span></p>
<p class="toc"><span href="#/xhtml/chapter05#sec34" title="Link target outside of Sample">Grape vines</span></p>
</div>
<p class="toca"><span href="#/xhtml/glossary" title="Link target outside of Sample"><em>Glossary</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?735d0500